export default __webpack_public_path__ + "static/media/cv151-4.a2018612.png";